import React from 'react'
import { default as Tippy, TippyProps } from '@tippyjs/react'
import { BoxProps, Box } from '../'
import { Theme } from 'theme-ui'

export const Tooltip = (props: TippyProps & BoxProps) => {
    const { children, content, ...tippyProps } = props

    return (
        <Tippy
            content={
                <Box
                    sx={{
                        borderRadius: 2,
                        fontSize: 3,
                        color: 'defaultText',
                        backgroundColor: 'mainBackground',
                        border: (t: Theme) =>
                            `1px solid ${t.colors?.inactiveText}`,
                        paddingX: 4,
                        paddingY: 2,
                        fontFamily: 'body'
                    }}
                >
                    {content}
                </Box>
            }
            {...tippyProps}
        >
            {children}
        </Tippy>
    )
}
